(function () {
  'use strict';

  angular.module('app').component('tourInventoryList', tourInventoryList());

  function tourInventoryList() {
    return {
      bindings: {
        calendarDays: '=',
        inventory: '=',
        onInventorySaved: '&',
      },
      controller: TourInventoryListCtrl,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/tour-inventories/tour-inventory-list/tour-inventory-list.component.html',
    };
  }

  TourInventoryListCtrl.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    '$filter',
    'AbilityService',
    'moment',
    'TourInventoryService',
  ];

  function TourInventoryListCtrl(
    config,
    UtilService,
    $filter,
    AbilityService,
    moment,
    TourInventoryService
  ) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canCreate: AbilityService.can('create_tourinventory_accountadmin'),
      canUpdate: AbilityService.can('update_tourinventory_accountadmin'),
      canSaveByDates: AbilityService.can('change_total_by_dates_tourinventory_accountadmin'),
    };

    vm.dateDisplay = config.DATE_DISPLAY_LARGE;
    vm.hourDisplay = config.HOUR_DISPLAY; // Ex: 01:00 PM

    vm.todayDateFormat = moment().format('YYYY-MM-DD');

    // Methods
    vm.openTourInventoryModal = openTourInventoryModal;
    vm.popoverPlacement = popoverPlacement;

    // Open the modal for masive add or update by date range
    function openTourInventoryModal(tour, option, schedule) {
      // if (!tour.has_prices){
      //     return;
      // }

      if (vm.permissions.canSaveByDates) {
        var selectedItem = tour;
        var title = tour.name;

        var inventory = {
          tour_id: tour.id,
          title: title,
          tour_option_id: null,
          tour_option_schedule_id: null,
        };

        if (option) {
          // if (!option.has_prices){
          //     return;
          // }

          selectedItem = option;
          inventory.tour_option_id = option.id;
          inventory.title = title + ' / ' + option.name;
        }

        if (schedule) {
          // if (!schedule.has_prices){
          //     return;
          // }

          selectedItem = schedule;
          inventory.tour_option_schedule_id = schedule.id;
          inventory.title =
            title +
            ' / ' +
            option.name +
            ' - ' +
            $filter('time')(schedule.departure, vm.hourDisplay);
        }

        var successCallback = function () {
          vm.onInventorySaved({ item: selectedItem });
        };

        TourInventoryService.openTourInventoryModal(inventory, successCallback);
      }
    }

    // Sets the popover placement (Left or Right)
    function popoverPlacement($index) {
      if (vm.calendarType === 'Month') {
        if ($index < 15) {
          return 'right';
        }
      }

      return 'left';
    }

    vm.popoverAdd = {
      templateUrl: 'template_add.html',
      open: function open(item) {
        // vm.newInventory = {
        // total_availability: 0,
        // };

        vm.newInventoryTotalAvailability = 0;

        item.popoverAddIsOpen = true;

        vm.selectedItem = item;
        vm.confirmCheckBox = false;

        // Add tour id, schedule, etc
      },
      close: function close(item) {
        item.popoverAddIsOpen = false;
        vm.selectedItem = null;
      },
      save: function save() {
        vm.selectedItem.total_availability = vm.newInventoryTotalAvailability; //vm.newInventory.total_availability;

        saveTourInventory();
      },
    };

    // Consider a sidebar modal with bokings created as reference
    vm.popoverUpdate = {
      templateUrl: 'template_update.html',
      open: function open(item) {
        vm.totalAvailabilityCopy = angular.copy(item.total_availability);
        item.popoverUpdateIsOpen = true;

        vm.selectedItem = item;
        vm.confirmCheckBox = false;
      },
      close: function close(item) {
        item.popoverUpdateIsOpen = false;
        vm.selectedItem = null;
      },
      save: function save() {
        vm.selectedItem.total_availability = vm.totalAvailabilityCopy;

        saveTourInventory();
      },
    };

    // Save-Update
    function saveTourInventory() {
      // console.log(vm.selectedItem);
      // return;

      vm.sendingForm = true;
      TourInventoryService.saveTourInventory(vm.selectedItem).then((response) => {
        if (response) {
          // vm.selectedItem = response.data;

          vm.selectedItem.popoverUpdateIsOpen = false;
          vm.selectedItem = null;

          vm.sendingForm = false;
        }
      });
    }
  }
})();
